import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchTreeData = createAsyncThunk('treedata/fetchTreeData', async (value) => {
  const response = await axios.get(`GetADDetails/getRoots?domainName=` + value);
  return response.data;
});
//fetch child ouData for Tree
export const getChildOuTreeData = createAsyncThunk('childOuTreeData/fetchTreeData', async (value) => {
  const response = await axios.get(`GetADDetails/getDirectChildOU?OU=${value.ouName}&FQDN=${value.fqdn}`);
  return response.data;
});

// function to update children in tree
export const updateChildrenInTree = (tree, parentId, updatedChildren) => {
  return tree.map((node) => {
    if (node.id === parentId) {
      return {
        ...node,
        children: updatedChildren,
      };
    } else if (node.children) {
      return {
        ...node,
        children: updateChildrenInTree(node.children, parentId, updatedChildren),
      };
    }
    return node;
  });
};
const handleAddOuInAdminTree = (tree, parentId, child) => {
  return tree.map((node) => {
    if (node.id === parentId) {
      if (node.children) {
        const filteredChildren = node.children.filter((child) => !child.id.includes('c'));
        let newObj = {
          id: `${parentId}-${filteredChildren.length + 1}`,
          name: child && child.ouName,
          dnName: child && child.dnName,
          hasChildren: true,
        };
        const newChildren = [
          ...node.children.slice(0, filteredChildren.length),
          newObj,
          ...node.children.slice(filteredChildren.length),
        ];
        return { ...node, children: newChildren };
      }
    } else if (node.children) {
      return {
        ...node,
        children: handleAddOuInAdminTree(node.children, parentId, child),
      };
    }
    return node;
  });
};
const handleDeleteOuInAdminTree = (tree, ouDnName) => {
  return tree.filter((node) => {
    if (node.dnName === ouDnName) {
      return false;
    }
    if (node.children) {
      node.children = handleDeleteOuInAdminTree(node.children, ouDnName);
    }
    return true;
  });
};
const handleUpdateOuInAdminTree = (tree, oldDnName, newName, newDnName) => {
  return tree.map((node) => {
    if (node.dnName === oldDnName) {
      return {
        ...node,
        name: newName,
        dnName: newDnName,
      };
    }
    if (node.children) {
      node.children = handleUpdateOuInAdminTree(node.children, oldDnName, newName, newDnName);
    }
    return node;
  });
};

const initialState = {
  data: [],
  loading: false,
  error: null,
  adminTreeExpandedKeys: [],
  adminTree: [],
  nodeKey: '',
};

const treeDataSlice = createSlice({
  name: 'treeData',
  initialState,
  reducers: {
    setExpandedKeysAdmin: (state, action) => {
      state.adminTreeExpandedKeys = action.payload;
    },
    setAdminTree: (state, action) => {
      state.adminTree = action.payload;
    },
    setNodekey: (state, action) => {
      state.nodeKey = action.payload;
    },
    addOuInAdminTree: (state, action) => {
      state.adminTree = handleAddOuInAdminTree(state.adminTree, action.payload.nodeKey, action.payload.child);
    },
    updateOuInAdminTree: (state, action) => {
      state.adminTree = handleUpdateOuInAdminTree(
        state.adminTree,
        action.payload.oldDnName,
        action.payload.newName,
        action.payload.newDnName
      );
    },
    deleteOuInAdminTree: (state, action) => {
      state.adminTree = handleDeleteOuInAdminTree(state.adminTree, action.payload);
    },
    resetTreeState: (state) => {
      return initialState;
    },
  },

  //GET Tree data

  extraReducers: (builder) => {
    builder
      .addCase(fetchTreeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTreeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchTreeData.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});
export const {
  setExpandedKeysAdmin,
  setAdminTree,
  setNodekey,
  resetTreeState,
  deleteOuInAdminTree,
  addOuInAdminTree,
  updateOuInAdminTree,
} = treeDataSlice.actions;
export default treeDataSlice.reducer;
